/**
 * Default Frontend Display Configuration for SPLH Dashboard
 *
 * This configuration file contains DISPLAY-ONLY settings for the frontend.
 * Backend configurations (table names, hierarchy levels, calculations, thresholds)
 * are handled by the backend resolver/Lambda.
 *
 * @module pages/common/dashboards/SPLHDashboard/config/default
 */

/**
 * Default configuration object
 * @type {Object}
 */
const defaultConfig = {
  /**
   * Breakdown modes available in the dashboard
   * @type {Array<Object>}
   */
  breakdownModes: [
    {
      key: 'daypart',
      label: 'Daypart',
      enabled: true,
    },
    {
      key: 'dayOfWeek',
      label: 'Day of Week',
      enabled: true,
    },
    {
      key: 'topPerformers',
      label: 'Top Performers',
      enabled: true,
    },
    {
      key: 'bottomPerformers',
      label: 'Bottom Performers',
      enabled: true,
    },
  ],

  /**
   * Display preferences for formatting and styling
   * @type {Object}
   */
  display: {
    /**
     * Currency format code
     * @type {string}
     */
    currencyFormat: 'USD',

    /**
     * Number of decimal places for SPLH values
     * @type {number}
     */
    decimalPlaces: 2,

    /**
     * Show trend indicators (arrows, colors)
     * @type {boolean}
     */
    showTrendIcons: true,

    /**
     * Chart color scheme
     * @type {Object}
     */
    chartColors: {
      splh: '#7C3AED', // Purple - primary SPLH line
      target: '#EF4444', // Red - target line
      positive: '#10B981', // Green - positive trend
      negative: '#EF4444', // Red - negative trend
      neutral: '#6B7280', // Gray - neutral/flat
    },

    /**
     * KPI display order
     * @type {Array<string>}
     */
    kpiOrder: ['splhTotal', 'splhFOH', 'splhBOH', 'totalSales', 'fohHours', 'bohHours'],

    /**
     * Target SPLH for reference line on chart (optional)
     * Set to null or 0 to hide target line
     * @type {number|null}
     */
    targetSPLH: null,
  },

  /**
   * Date range preset options
   * @type {Array<Object>}
   */
  dateRangePresets: [
    {
      key: 'today',
      label: 'Today',
    },
    {
      key: 'yesterday',
      label: 'Yesterday',
    },
    {
      key: 'last7days',
      label: 'Last 7 Days',
    },
    {
      key: 'last30days',
      label: 'Last 30 Days',
    },
    {
      key: 'mtd',
      label: 'Month to Date',
    },
    {
      key: 'custom',
      label: 'Custom Range',
    },
  ],
};

export default defaultConfig;
